import httpAuth from "../../services/httpAuth";
import {
  getHomeAllCompetitionSuccess,
  getHomeAllCompetitionError,
  getHomeAllEventsSuccess,
  getHomeAllEventsError,
} from "./homeMarketEvents.slice";

export const requestHomeAllCompetition =
  (data) => async (dispatch, getState) => {
    const auth = getState().auth;

    if (!auth) {
      try {
        const response = await httpAuth.post("series/series", data);
        if (response.status === 200 && response?.data?.status) {
          dispatch(getHomeAllCompetitionSuccess(response?.data?.data));
        }

        return response;
      } catch (e) {
        dispatch(getHomeAllCompetitionError());
      }
    } else {
      try {
        const response = await httpAuth.post(`series/getSeries`, data);
        if (response?.data?.status) {
          dispatch(getHomeAllCompetitionSuccess(response?.data?.data));
        }

        return response;
      } catch (e) {
        dispatch(getHomeAllCompetitionError());
      }
    }
  };

export const requestHomeAllEvents = (data) => async (dispatch, getState) => {
  const auth = getState().auth;
  if (auth) {
    try {
      const response = await httpAuth.post("getHomeAllEvents", data);
      if (response.status === 200 && response?.data?.success) {
        setTimeout(() => {
          dispatch(getHomeAllEventsSuccess(response?.data?.response));
        }, 500);
      }

      return response;
    } catch (e) {
      dispatch(getHomeAllEventsError());
    }
  } else {
    try {
      const response = await httpAuth.post(`getFreeHomeAllEvents`, data);
      if (response.status === 200 && response?.data?.success) {
        setTimeout(() => {
          dispatch(getHomeAllEventsSuccess(response?.data?.response));
        }, 500);
      }

      return response;
    } catch (e) {
      dispatch(getHomeAllEventsError());
    }
  }
};
